import {React, useRef, useState } from "react";
import style from "./style.module.css";
import { weatherService } from "../services/weatherService";
import { ErrorDialog } from "./ErrorDialog";
const Main = () => {

    const [data, setData] = useState({});
    const [location, setLocation] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const dialogEle = useRef(null);

    const searchLocation = async (event) => {
        if (event.key === 'Enter' && location.trim() !== ""){
            try {
                const weatherData = await weatherService(location.trim());
                if(weatherData && !weatherData.weather){
                    handleError(weatherData);
                } else {
                    setData(weatherData);
                    setErrorMsg("");
                }
            } catch(err){
                handleError(err)
            } 
        }
    }

    const handleError = (err) => {
        const message = err.response?.data?.message || "City not found!";
        setErrorMsg(message);
        dialogEle.current.showModal();
        setTimeout(() => {
            dialogEle.current.close();
        }, 2500);
    }

    return (
        <>
        <section id="main-section">
            <div>
                <div><input id={style.search} type="text" placeholder="Enter city" value={location} onChange={event => setLocation(event.target.value)} onKeyPress={searchLocation} /></div>
                <div id={style.cardtemp}>
                    <div id={style.temprature}>
                        {data.main ? <h1>{Math.round(data.main.temp)}°C</h1> : <h1>0°C</h1>}
                    </div>
                    <div id={style.location}>
                        {data.weather ? <h2>{data.name}</h2> : "Enter location"}
                        {data.weather ? <span>{data.weather[0].main}</span> : ""}
                    </div>
                    <div id={style.cardbottom}>
                        <div>
                            {data.main ? <div className={style.circle}>{Math.round(data.main.feels_like)}°C</div> : <div className={style.circle}>°C</div>}
                            <p>Feels Like</p>
                        </div>
                        <div>
                            {data.main ? <div className={style.circle}>{data.main.humidity}%</div> : <div className={style.circle}>0%</div>}
                            <p>Humidity</p>
                        </div>
                        <div>
                            {data.wind ? <div className={style.circle}>{data.wind.speed}<br />m/s</div> : <div className={style.circle}>0<br />m/s</div>}
                            <p>Wind Speed</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ErrorDialog 
                modalRef={dialogEle}
                message={errorMsg}
            />
        </>
    )
}
export default Main